module.exports = __webpack_public_path__ + "static/media/finance-main.2b2e2487.svg";